import { useState } from 'react'

import MoreHorizontalIcon from '@icons/MoreHorizontalIcon'

import MenuMui from '@mui/material/Menu'
import IconButton from '@components/_mui/IconButton'

export default function Menu({ children }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClose = () => setAnchorEl(null)
  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event?.currentTarget)
  }

  return (
    <>
      <IconButton
        size="small"
        component="div"
        onClick={(e) => handleClick(e)}
        sx={{
          color: 'grey.900',
          my: -1,
          mr: 0.5,
        }}
      >
        <MoreHorizontalIcon />
      </IconButton>
      <MenuMui
        id="card-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          list: { 'aria-labelledby': 'card-menu-button' },
        }}
      >
        {children({ close: handleClose })}
      </MenuMui>
    </>
  )
}
